module.exports = __webpack_public_path__ + "img/Tableau.863588a7.png";